import { claimsTypeAdd, claimsTypeEdit } from './request';
// const ADD_RULES = {
//   name: [
//     {required: true, message: Vue.$i18n.$t('请输入') + Vue.$i18n.$t('理赔类型'), trigger: 'blur'},
//     {message: '1-50' + Vue.$i18n.$t('字符'), max: 50, min: 1}
//   ],
//   description: [
//     {required: true, message: this.$t('请输入') + Vue.i18n.$t('类型说明'), trigger: 'blur'},
//     {message: '1-200' + Vue.i18n.$t('字符'), max: 200, min: 1}
//   ],
//   sort: [{required: true, message: Vue.i18n.$t('请输入') + Vue.i18n.$t('排序号'), trigger: 'blur'}]
// };
export default {
  data() {
    return {
      addVisible: false,
      addForm: {
        claimsTypeId: null,
        name: '',
        description: '',
        sort: 0,
        parentId: '',
        parent: ''
      },
      continueState: false,
      status: '',
      ident: false,
      isContinue: true
    };
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('理赔类型'),
          trigger: 'blur'
        }, {
          message: '1-50' + this.$t('字符'),
          max: 50,
          min: 1
        }],
        description: [{
          required: true,
          message: this.$t('请输入') + this.$t('类型说明'),
          trigger: 'blur'
        }, {
          message: '1-200' + this.$t('字符'),
          max: 200,
          min: 1
        }],
        sort: [{
          required: true,
          message: this.$t('请输入') + this.$t('排序号'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    openModal(type, info, isContinue) {
      this.isContinue = isContinue;
      this.status = type;
      this.emptyForm();
      if (info) {
        if (info.isChild || type === 'add') {
          this.ident = true;
          this.addForm.parent = info.name;
          this.addForm.parentId = info.claimsTypeId;
        } else {
          this.ident = false;
          Object.assign(this.addForm, info);
        }
      } else {
        this.ident = false;
      }
      this.addVisible = true;
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          let addParams;
          if (this.status === 'edit') {
            await claimsTypeEdit(Object.assign(this.addForm, {
              isContinue: this.isContinue
            }));
          } else {
            this.addForm.claimsTypeId = null;
            const res = await claimsTypeAdd(Object.assign(this.addForm, {
              isContinue: this.isContinue
            }));
            addParams = res;
          }
          if (!(!this.isContinue && this.status == 'add')) {
            this.$message.success(this.$t('保存成功'));
          }
          if (this.continueState) {
            this.addForm.claimsTypeId = null;
            this.addForm.name = '';
            this.addForm.description = '';
            this.addForm.sort = '';
          } else {
            this.addVisible = false;
          }
          this.$emit('save', addParams);
        }
      });
    },
    closeAddVisible() {
      this.addVisible = false;
      this.continueState = false;
      this.emptyForm();
      this.resetForm();
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    },
    emptyForm() {
      this.addForm.claimsTypeId = null;
      this.addForm.name = '';
      this.addForm.description = '';
      this.addForm.sort = '';
      this.addForm.parentId = '';
      this.addForm.parent = '';
    }
  }
};